import { connect } from 'react-redux';
import { channelLayoutValues } from 'default-settings';

import { videosPerPage } from 'widget/utils/videos-sizes';
import BIUnhandledErrorLogger from 'shared/bi/bi-unhandled-error-logger';

import { COMPACT_NUMBER_OF_ROWS, COMPACT_VIDEOS_IN_ROW } from 'shared/constants/compact-layout';

import { getChannelForWidget } from 'shared/selectors/channels';
import {
  getAllSettings,
  getNumberOfRows,
  getEditMode,
  getIsInitialWidgetSizeWasSet,
  getChannelLayout,
} from 'shared/selectors/app-settings';

import getVideoIdFromUrl from 'widget/selectors/video-id-from-url';
import { getSearchQuery, getSearchQueryField } from '../../../shared/selectors/search';
import { getMainVideoId } from 'widget/ui-selectors/selected-video-id';
import { selectVideo } from 'widget/redux/client/actions/select-video';

import TooltipPopout from 'shared/components/tooltip/tooltip-popout';
import Modal from 'shared/components/modal/modal';

import BiHandler from 'shared/bi/bi-handler';
import ExperimentsLoader from 'shared/data-components/experiments';
import AppSettingsLoader from 'widget/data-components/app-settings';
import UpdateChannelPublishedState from 'widget/data-components/update-channel-published-state';
import ChannelLoader from 'widget/data-components/channel';
import PaymentInfoLoader from 'widget/data-components/payment-info';
import ChannelVideoLoader from 'widget/data-components/channel-video';
import PaginatedChannelVideosLoader, { DATA_KEY as PAGINATED_VIDEOS_KEY } from 'widget/data-components/paginated-channel-videos';
import NextChannelVideosLoader from 'widget/data-components/next-channel-videos';
import CurrentSiteUser from 'widget/data-components/current-site-user';
import ReloadChannelPaymentDataOnPayment from 'widget/data-components/reload-channel-payment-data-on-payment';
import ClearVideoUrlsCacheOnPayment from 'widget/data-components/clear-video-urls-cache-on-payment';
import SetInitialWidgetSize from 'widget/data-components/set-initial-widget-size';
import PaymentEventProxy from 'shared/components/payment-events/proxy';
import PaymentsBiHandler from 'widget/components/payments/bi-handler';


import 'shared/styles/core.styl';


@connect(state => ({
  appSettings: getAllSettings(state),
  selectedVideoId: state.selectedVideoId,
  channelData: getChannelForWidget(state),
  currentChannelId: state.currentChannelId,
  mainVideoId: getMainVideoId(state, PAGINATED_VIDEOS_KEY),
  numberOfRows: getNumberOfRows(state),
  videoIdFromUrl: getVideoIdFromUrl(state),
  searchQuery: getSearchQuery(state),
  searchQueryField: getSearchQueryField(state),
  editMode: getEditMode(state),
  isInitialWidgetSizeWasSet: getIsInitialWidgetSizeWasSet(state),
  layout: getChannelLayout(state),
}),
  {
    selectVideo,
  }
)
export default class DesktopLayout extends React.Component {

  static propTypes = {
    selectedVideoId: React.PropTypes.string,
    children: React.PropTypes.element,
    currentChannelId: React.PropTypes.string,
    mainVideoId: React.PropTypes.string,
    videoIdFromUrl: React.PropTypes.string,
    channelData: React.PropTypes.object,
    appSettings: React.PropTypes.object,
    selectVideo: React.PropTypes.func,
    numberOfRows: React.PropTypes.number,
    searchQuery: React.PropTypes.string,
    searchQueryField: React.PropTypes.string,
    editMode: React.PropTypes.string,
    isInitialWidgetSizeWasSet: React.PropTypes.bool,
    layout: React.PropTypes.number,
  };

  componentWillUpdate(nextProps) {
    const { videoIdFromUrl, selectedVideoId } = nextProps;
    if (videoIdFromUrl && !selectedVideoId) {
      this.props.selectVideo(videoIdFromUrl);
    }
  }

  // Todo: move to loader or reducer
  get videosPerPage() {
    const { appSettings, numberOfRows, channelData } = this.props;
    const { videosInRow, channelLayout } = appSettings.numbers;
    const isStrip = channelLayout === channelLayoutValues.STRIP;
    const isCompact = channelLayout === channelLayoutValues.COMPACT;

    if (isCompact) {
      return COMPACT_NUMBER_OF_ROWS * COMPACT_VIDEOS_IN_ROW;
    }

    if (isStrip) {
      return videosInRow * numberOfRows;
    }

    const allVideosCount = channelData && channelData.videosCount;

    return videosPerPage(
      appSettings.requestedWidgetSize,
      videosInRow,
      allVideosCount,
      appSettings,
      channelData || {},
    );
  }

  get content() {
    const {
      children, appSettings, mainVideoId, videoIdFromUrl, currentChannelId, selectedVideoId, isInitialWidgetSizeWasSet,
    } = this.props;

    if (!appSettings || !currentChannelId || !isInitialWidgetSizeWasSet) {
      return null;
    }

    const { searchQuery, searchQueryField } = this.props;
    const nextChannelVideosVideoId = selectedVideoId || videoIdFromUrl || mainVideoId;

    return (
      <ChannelLoader channelId={currentChannelId}>
        <PaginatedChannelVideosLoader channelId={currentChannelId}
                                      videosPerUIPage={this.videosPerPage}
                                      searchQuery={searchQuery}
                                      searchQueryField={searchQueryField}
                                      as={PAGINATED_VIDEOS_KEY}>
          <ChannelVideoLoader channelId={currentChannelId}
                              videoId={videoIdFromUrl}>
            <NextChannelVideosLoader channelId={currentChannelId}
                                     currentVideoId={nextChannelVideosVideoId}>
              <CurrentSiteUser>
                <PaymentInfoLoader channelId={currentChannelId}>
                  {children}
                  <PaymentEventProxy />
                  <ReloadChannelPaymentDataOnPayment />
                  <ClearVideoUrlsCacheOnPayment />
                </PaymentInfoLoader>
              </CurrentSiteUser>
            </NextChannelVideosLoader>
          </ChannelVideoLoader>
        </PaginatedChannelVideosLoader>
      </ChannelLoader>
    );
  }

  render() {
    const { currentChannelId, appSettings, editMode, layout } = this.props;

    return (
      <div data-layout={layout}
           data-view-mode={editMode}>
        <SetInitialWidgetSize />
        <ExperimentsLoader>
          <BiHandler />
          <BIUnhandledErrorLogger />
          <PaymentsBiHandler />
          <AppSettingsLoader />
          <UpdateChannelPublishedState channelId={currentChannelId} />
          {this.content}

          <Modal settings={appSettings} />
          <TooltipPopout />
        </ExperimentsLoader>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/layouts/desktop/desktop.js